module.exports = __webpack_public_path__ + "static/media/icon-money-2.87217f90.svg";